import { render, staticRenderFns } from "./NpaHistoryChanges.vue?vue&type=template&id=24aa9621"
import script from "./NpaHistoryChanges.vue?vue&type=script&lang=js"
export * from "./NpaHistoryChanges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports